import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ReactInputMask from "react-input-mask";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import axios from "axios";

import "./step-1.scss";
import { LoadingContext } from "../../../../contexts/loadingContext";
import { CartContext } from "../../../../contexts/cartContext";
import { FranchiseContext } from "./../../../../contexts/franchiseContext";
import { AuthUserContext } from "../../../../contexts/authUserContext";
import Swal from "sweetalert2";
import api from "../../../../services/api";

const schema = yup.object().shape({
  cep: yup
    .string()
    .matches(/^\d{5}-\d{3}$/, "Digite um CEP válido!")
    .required("CEP é uma informação obrigatória!"),
  endereco: yup.string().required("O campo endereço é obrigatório."),
  numero: yup.string().required("O campo número é obrigatório."),
  complemento: yup.string(),
  bairro: yup.string().required("O campo bairro é obrigatório."),
  cidade: yup.string().required("O campo cidade é obrigatório."),
  estado: yup.string().required("O campo estado é obrigatório."),
  frete: yup.string().required("É nessário escolher uma forma de envio!"),
});

function Step1({ nextStep, formData }) {
  const [isValidCEP, setIsValidCEP] = useState(false);
  const { authUser } = useContext(AuthUserContext);
  const { setIsLoadingGlobal } = useContext(LoadingContext);
  const { cartShippingType, setCartShippingType, setCartShippingPrice } = useContext(CartContext);
  const { franchise } = useContext(FranchiseContext);

  const [selectedOption, setSelectedOption] = useState(cartShippingType);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      cidade: formData.cidade,
      estado: formData.estado,
      frete: cartShippingType
    }
  });

  const handleRadioChange = (element) => {
    setCartShippingType(element.value);
    setSelectedOption(element.value);
  };

  const onSubmit = (data) => {
    let newData = { ...formData, ...data, order_shipping_type_code: 1 };
    nextStep(newData);
  };

  const handleCepBlur = async (e) => {
    const cleanedCEP = e.target.value.replace("-", "");
    if (cleanedCEP.length === 8) {
      try {
        setIsLoadingGlobal(true);

        const checkIfCepIsAvailableResponse = await api.get(`/franchises/${franchise.id}/shipping_cost?zip_code=${cleanedCEP}`);

        if (checkIfCepIsAvailableResponse.status === 200) {
          setCartShippingPrice(checkIfCepIsAvailableResponse.data.shipping_cost);
        }

        const response = await axios.get(
          `https://viacep.com.br/ws/${cleanedCEP}/json/`
        );
        if (response.erro) {
          alert("CEP não encontrado");
          reset({
            cep: "",
            endereco: "",
            bairro: "",
            cidade: "",
            estado: "",
            numero: "",
            complemento: "",
          });
          setIsValidCEP(false);
          return;
        }
        setValue("endereco", response.data.logradouro);
        setValue("bairro", response.data.bairro);
        setValue("estado", response.data.estado);
        setValue("cidade", response.data.localidade);
        setIsValidCEP(true);
      } catch (error) {
        setIsValidCEP(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.error
        });
      } finally {
        setIsLoadingGlobal(false);
      }
    }
  };

  return (
    <div className="form step-1">
      <div className={`dispatch-container ${isMobile ? "mt-5" : "mt-4"}`}>
        <h1 className="title">Escolha uma forma de envio</h1>
        <div className="radio-container">
          <div
            className={`form-radio-control w-100 d-flex mb-4 p-2 ${selectedOption === "entrega" ? "selected" : ""
              }`}
          >
            <input
              className="radio-big"
              type="radio"
              {...register("frete")}
              id="entrega"
              defaultChecked={formData.frete === "entrega" ? true : false}
              value="entrega"
              onClick={(e) => handleRadioChange(e.target)}
            />
            <div className="label-box ms-2">
              <h1>
                Entrega realizada pela Adoleta <strong>Grátis!</strong>
              </h1>

              <h4
                style={isMobile ? { lineHeight: 1.4 } : { lineHeight: 1.2 }}
              >
                Prazo da entrega:
                <strong>
                  {" "}
                  3 dias úteis após a confirmação do pagamento.
                </strong>
              </h4>
            </div>
          </div>
          <div
            className={`form-radio-control w-100 d-flex mb-4 p-2 ${selectedOption === "retirar" ? "selected" : ""
              }`}
          >
            <input
              className="radio-big"
              type="radio"
              {...register("frete")}
              id="retirar"
              defaultChecked={formData.frete === "retirar" ? true : false}
              value="retirar"
              onClick={(e) => handleRadioChange(e.target)}
            />
            <div className="label-box ms-2">
              <h1>
                Retirar na Adoleta <strong>Grátis!</strong>
              </h1>
              <h4>
                Prazo de retirada:
                <strong>
                  {" "}
                  2 dias úteis após a confirmação do pagamento.
                </strong>
              </h4>
              <h4>Entrar em contato atráves do WhatsApp (83) 99380-1284</h4>
            </div>
          </div>
        </div>
        {errors.frete ? (
          <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-x-circle-fill"
              viewBox="0 0 16 16"
            >
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
            </svg>
            <p>{errors.frete.message}</p>
          </div>
        ) : (
          ""
        )}
      </div>
      {selectedOption === "entrega" ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row form-title mb-4">
            <h1>Insira seu endereço</h1>
          </div>
          <div className={`${isMobile ? "" : "row"}`}>
            <div className={`mb-4 ${isMobile ? "" : "col-3"}`}>
              <label className="form-label">CEP</label>
              <ReactInputMask
                className="form-control"
                mask="99999-999"
                placeholder="Digite seu CEP"
                maskChar={null}
                defaultValue={formData.cep ? formData.cep : ""}
                {...register("cep")}
                onBlur={handleCepBlur}
              >
                {(inputProps) => <input {...inputProps} />}
              </ReactInputMask>
              {errors.cep ? (
                <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-x-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                  </svg>
                  <p>{errors.cep.message}</p>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className={`mb-4 ${isMobile ? "" : "col-6"}`}>
              <label className="form-label">Endereco</label>
              <input
                type="text"
                className="form-control"
                id="endereco"
                placeholder="Informe antes seu CEP"
                defaultValue={formData.endereco ? formData.endereco : ""}
                {...register("endereco")}
              />
              {errors.endereco ? (
                <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-x-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                  </svg>
                  <p>{errors.endereco.message}</p>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className={`mb-4 ${isMobile ? "" : "col-3"}`}>
              <label className="form-label">Número</label>
              <input
                type="number"
                className="form-control"
                id="numero"
                placeholder="Número"
                defaultValue={formData.numero ? formData.numero : ""}
                {...register("numero")}
              />
              {errors.numero ? (
                <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-x-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                  </svg>
                  <p>{errors.numero.message}</p>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className={`${isMobile ? "" : "row"}`}>
            <div className="col mb-4">
              <label className="form-label">Bairro</label>
              <input
                type="text"
                className="form-control"
                id="bairro"
                placeholder="Informe antes seu CEP"
                defaultValue={formData.bairro ? formData.bairro : ""}
                {...register("bairro")}
              />
              {errors.bairro ? (
                <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-x-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                  </svg>
                  <p>{errors.bairro.message}</p>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="col mb-4">
              <label className="form-label">Complemento</label>
              <input
                type="text"
                className="form-control"
                id="complemento"
                placeholder="Informação opcional"
                defaultValue={formData.complemento ? formData.complemento : ""}
                {...register("complemento")}
              />
            </div>
          </div>
          <div className={`${isMobile ? "" : "row"}`}>
            <div className="col mb-4">
              <label className="form-label">Cidade</label>
              <input
                type="text"
                className={`form-control disabled`}
                id="cidade"
                placeholder="Cidade"
                disabled
                defaultValue={formData.cidade ? formData.cidade : ""}
                {...register("cidade")}
              />
              {errors.cidade ? (
                <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-x-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                  </svg>
                  <p>{errors.cidade.message}</p>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="col mb-4">
              <label className="form-label">Estado</label>
              <input
                type="text"
                className={`form-control disabled`}
                id="estado"
                placeholder="Estado"
                disabled
                defaultValue={formData.estado ? formData.estado : ""}
                {...register("estado")}
              />
              {errors.estado ? (
                <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-x-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                  </svg>
                  <p>{errors.estado.message}</p>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div
            className={`w-100 d-flex mt-5 ${isMobile ? "flex-column gap-3 pb-5 mobile" : ""
              } justify-content-between buttons`}
          >
            <Link
              to={"/brinquedos-adoleta"}
              type="button"
              className={`btn button-control button-prev ${isMobile ? "d-flex align-items-center justify-content-center" : ""
                }`}
            >
              Escolher mais brinquedos
            </Link>
            <button type="submit" className="btn button-control button-next">
              Avançar
            </button>
          </div>
        </form>
      ) : (
        <div
          className={`w-100 d-flex mt-5 ${isMobile ? "flex-column gap-3 pb-5 mobile" : ""
            } justify-content-between buttons`}
        >
          <Link
            to={"/brinquedos-adoleta"}
            type="button"
            className={`btn button-control button-prev ${isMobile ? "d-flex align-items-center justify-content-center" : ""
              }`}
          >
            Escolher mais brinquedos
          </Link>
          <button className="btn button-control button-next" onClick={() => nextStep({ ...formData, order_shipping_type_code: 2 })}>
            Avançar
          </button>
        </div>
      )}
    </div>
  );
}

export default Step1;
